import { useState } from "react";

interface IModalChildren {
  modal?: object;
  openModal?(name: string, data?: any): void;
  closeModal?(name: string): void;
}

export interface ModalManagerProps {
  initialValue?: object;
  children?({ modal, openModal, closeModal }: IModalChildren): void;
}

const defaultValue = {
  create: { isOpen: false },
  update: { isOpen: false, data: {} }
};

export default ({ initialValue = defaultValue, children = () => {} }: ModalManagerProps) => {
  const [state, setState] = useState(initialValue);

  const openModal = (name: string, data: any = {}) => setState({ ...state, [name]: { isOpen: true, data } });
  const closeModal = (name: string) => setState({ ...state, [name]: { isOpen: false, data: {} } });

  return children({ modal: state, openModal, closeModal });
};
